import { useCallback } from "react";
import s3Service from "../services/s3Service";

const useS3 = () => {
	// const getUploadUrl = useCallback(async (fileName: string, contentType?: string) => {
	// 	try {
	// 		return s3Service.getS3UploadUrl(fileName, contentType ?? 'application/octet-stream');
	// 	} catch (error) {
	// 		return Promise.reject(`Error retrieving upload URL: ${error}`);
	// 	}
	// }, []);

	const getDownloadUrl = useCallback(async (fileName: string) => {
		try {
			return s3Service.getS3DownloadUrl(fileName);
		} catch (error) {
			return Promise.reject(`Error retrieving download URL: ${error}`);
		}
	}, []);

	// const deleteFile = useCallback(async (fileName: string) => {
	// 	try {
	// 		return s3Service.deleteFile(fileName);
	// 	} catch (error) {
	// 		return Promise.reject(`Error deleting file: ${error}`);
	// 	}
	// }, []);

	return { /* getUploadUrl, */ getDownloadUrl, /* deleteFile */ };
};

export default useS3;